const GET_DMI_VERIFICATIONS_DATA: string = 'GET_DMI_VERIFICATIONS_DATA';
const GET_DMI_VLP_VERIFICATIONS_DATA: string = 'GET_DMI_VLP_VERIFICATIONS_DATA';
const GET_CURRENT_USER_VIEWREF: string = 'GET_CURRENT_USER_VIEWREF';
const GET_HOUSEHOLD_INCOME: string = 'GET_HOUSEHOLD_INCOME';
const UPLOAD_VERIFICATION_DOCUMENTS: string = 'UPLOAD_VERIFICATION_DOCUMENTS';
const UPDATE_DOCUMENT_CATEGORY_DETAIL_LIST:string = 'UPDATE_DOCUMENT_CATEGORY_DETAIL_LIST';

export const DMI_ACTION_TYPES = {
    GET_DMI_VERIFICATIONS_DATA,
    GET_DMI_VLP_VERIFICATIONS_DATA,
    GET_CURRENT_USER_VIEWREF,
    GET_HOUSEHOLD_INCOME,
    UPLOAD_VERIFICATION_DOCUMENTS,
    UPDATE_DOCUMENT_CATEGORY_DETAIL_LIST
};